import { sendResultsToEmail } from '@/services/api/requests/public-screener';
import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { TSendResultsToEmailForBE } from '@/types/PublicScreener.types';
import { TCustomAxiosError } from '@/services/api';

const useSendResultToEmail = (turnstileToken: string | null, onSuccessCallback?: (email: string) => void ) => {
  const toast = useToast();

  const { isPending, mutate, isSuccess } = useMutation({
    mutationFn: async ({ email, organizationSlug, submissionId }: TSendResultsToEmailForBE) => {
      if (!turnstileToken) {
        throw new Error('Turnstile token is required');
      }

      await sendResultsToEmail({ formData: {email, organizationSlug, submissionId}, turnstileToken });

      return email;
    },
    onSuccess: (email) => {
      toast({
        status: 'success',
        title: 'Success',
        description: 'Screener Results emailed successfully.',
      });

      setTimeout(() => {
        onSuccessCallback?.(email);
      }, 1500);
    },
    onError:(error: TCustomAxiosError) => {
      toast({
        title: 'Error while sending Screener Results to email',
      }, error);
    },
  });

  return { isPending, mutate, isSuccess };
};

export default useSendResultToEmail;
